import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconBuildings12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconBuildings12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M3.5 6.5h1m-4 4h1m2-2h1m2 2v-6l4-1.5v5.5m-4 2h-5m5 0h5m-10 0v-8l5-2v2m1.5 4h1m-1 2h1m-5.5-4h1"
            />
        </svg>
    );
}
export default memo(IconBuildings12);
